import {connect} from "react-redux"
import State from "../../models/State"

export const mapStateToProps = (state: State) => {
    const {template, search} = state

    return {
        templating: template,
        globalPriceFormattingConfig: search.globalPriceFormattingConfig,
    }
}

export default connect(mapStateToProps)
